import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { PAGE_ROUTE } from '~/constants';
import useToast from '~/store/useToast';

const useErrorHandler = () => {
  const navigate = useNavigate();
  const { showToast } = useToast();

  const handleChatError = useCallback(
    (statusCode: number, redirectPath = PAGE_ROUTE.MAIN) => {
      switch (statusCode) {
        case 404:
          showToast('error', 'There is no chatroom with the specified ID.');
          break;
        case 409:
          showToast(
            'error',
            'The number of participants has exceeded the limit.',
          );
          break;
        case 403:
          showToast('error', 'Password does not match.');
          break;
        default:
          showToast('error', 'something wrong. please try again.');
      }
      navigate(redirectPath, { replace: true });
    },
    [navigate, showToast],
  );

  return { handleChatError };
};

export default useErrorHandler;
